import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var XltxShortcutSvg = function XltxShortcutSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M19.75 21a.75.75 0 0 0 .75-.75v-16h-.25V2.5l1.5 1v.25h-.25v18a.25.25 0 0 1-.25.25H10.065q.24-.485.423-1z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M6.5 10.204A9 9 0 0 1 11 18c0 .867-.123 1.706-.352 2.5h9.102a.25.25 0 0 0 .25-.25v-16H6.5z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#33C481",
      d: "M20.5 1.549a.5.5 0 0 0-.207-.049H6.5A.5.5 0 0 0 6 2v2l.25.25h14L20.5 4v-.625l.25-.25V2.25z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#21A366",
      fillRule: "evenodd",
      d: "m22 4.5-1.073-1.073a.25.25 0 0 0-.427.177V1.549a.5.5 0 0 1 .146.098l1.207 1.207a.5.5 0 0 1 .147.353zM20.5 4H6v.5h14.5z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#605E5C",
      fillRule: "evenodd",
      d: "M21.5 21.75v-18h.5v18a.75.75 0 0 1-.75.75H9.796q.142-.245.269-.5H21.25a.25.25 0 0 0 .25-.25M10.488 21h9.262a.75.75 0 0 0 .75-.75v-16H20v16a.25.25 0 0 1-.25.25h-9.102a9 9 0 0 1-.16.5M6.5 4.25v5.954a9 9 0 0 0-.5-.268V4.25z",
      clipRule: "evenodd",
      opacity: 0.64
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#107C41",
      fillRule: "evenodd",
      d: "M2 9v-.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.014q.015-.248.014-.5a9 9 0 0 0-9-9",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F9F7F7",
      fillRule: "evenodd",
      d: "M6.127 10q.15.076.294.159L6.341 10zm1.89 1.307L8.727 10h1.303l-1.26 2.07a9 9 0 0 0-.753-.763",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#134A2C",
      d: "M18 15.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#185C37",
      d: "M15 14.5h-1v1h1a.5.5 0 0 0 0-1"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#21A366",
      d: "M18 13.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#107C41",
      d: "M15 12.5h-1v1h1a.5.5 0 0 0 0-1"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#33C481",
      d: "M18 11.5h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#21A366",
      d: "M15 10.5h-1v1h1a.5.5 0 0 0 0-1"
    })]
  });
};
export var XltxShortcut = function XltxShortcut(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: XltxShortcutSvg
  }));
};